import storage from 'store'

const CLOUD_SERVER_KEY = 'ViwoodsCloudServerKey'
const CLOUD_TEST_HOSTNAME = 'cloudtest.viwoods.com'
let initialConfigBaseUrl = ''

export const CLOUD_SERVER_US = 'us'
export const CLOUD_SERVER_SG = 'sg'
export const CLOUD_SERVER_CN = 'cn'

export const CLOUD_SERVERS = {
  [CLOUD_SERVER_US]: {
    key: CLOUD_SERVER_US,
    baseUrl: 'https://apitest.viwoods.com',
    aliases: ['https://apitest.viwoods.com', 'https://api.viwoods.com'],
    upload: {
      init: 'api/v2/cloud/upload/init',
      complete: 'api/v2/cloud/upload/complete'
    }
  },
  [CLOUD_SERVER_SG]: {
    key: CLOUD_SERVER_SG,
    baseUrl: 'https://sg.viwoods.com',
    aliases: ['https://sg.viwoods.com'],
    upload: {
      init: 'api/v2/cloud/upload/oss/init',
      complete: 'api/v2/cloud/upload/oss/complete'
    }
  },
  [CLOUD_SERVER_CN]: {
    key: CLOUD_SERVER_CN,
    baseUrl: 'https://apisz.wisky.com.cn',
    aliases: ['https://apisz.wisky.com.cn'],
    upload: {
      init: 'api/v2/cloud/upload/oss/init',
      complete: 'api/v2/cloud/upload/oss/complete'
    }
  }
}

export function normalizeCloudBaseUrl(value) {
  return String(value || '').trim().replace(/\/+$/, '')
}

export function normalizeCloudServerKey(value) {
  const key = String(value || '').trim().toLowerCase()
  return Object.prototype.hasOwnProperty.call(CLOUD_SERVERS, key) ? key : ''
}

export function isCloudTestEnvironment() {
  if (typeof window === 'undefined') {
    return false
  }
  const hostname = String(window.location && window.location.hostname ? window.location.hostname : '').trim().toLowerCase()
  return hostname == CLOUD_TEST_HOSTNAME
}

export function getCloudServerKeyByBaseUrl(baseUrl) {
  const normalizedUrl = normalizeCloudBaseUrl(baseUrl)
  if (!normalizedUrl) {
    return ''
  }
  const serverKeys = Object.keys(CLOUD_SERVERS)
  for (let i = 0; i < serverKeys.length; i++) {
    const server = CLOUD_SERVERS[serverKeys[i]]
    const aliases = Array.isArray(server.aliases) ? server.aliases : [server.baseUrl]
    if (aliases.map(normalizeCloudBaseUrl).includes(normalizedUrl)) {
      return server.key
    }
  }
  return ''
}

export function getConfigBaseUrl() {
  if (typeof window === 'undefined') {
    return ''
  }
  const baseUrl = normalizeCloudBaseUrl(window.g && window.g.baseUrl)
  if (baseUrl && !initialConfigBaseUrl) {
    initialConfigBaseUrl = baseUrl
  }
  return baseUrl
}

export function getInitialConfigBaseUrl() {
  return initialConfigBaseUrl || getConfigBaseUrl()
}

function getConfiguredBaseUrlForServer(serverKey) {
  const configBaseUrl = getInitialConfigBaseUrl()
  if (configBaseUrl && getCloudServerKeyByBaseUrl(configBaseUrl) == serverKey) {
    return configBaseUrl
  }
  return ''
}

export function getStoredCloudServerKey() {
  if (isCloudTestEnvironment()) {
    return CLOUD_SERVER_US
  }
  return normalizeCloudServerKey(storage.get(CLOUD_SERVER_KEY))
}

export function getActiveCloudServerKey() {
  if (isCloudTestEnvironment()) {
    return CLOUD_SERVER_US
  }
  return getStoredCloudServerKey()
    || getCloudServerKeyByBaseUrl(getConfigBaseUrl())
    || CLOUD_SERVER_US
}

export function getCloudBaseUrl(serverKey) {
  const key = isCloudTestEnvironment() ? CLOUD_SERVER_US : (normalizeCloudServerKey(serverKey) || getActiveCloudServerKey())
  const configuredBaseUrl = getConfiguredBaseUrlForServer(key)
  if (configuredBaseUrl) {
    return configuredBaseUrl
  }
  const server = CLOUD_SERVERS[key]
  return normalizeCloudBaseUrl(server && server.baseUrl ? server.baseUrl : getConfigBaseUrl())
}

export function setCloudServerKey(serverKey) {
  const key = isCloudTestEnvironment() ? CLOUD_SERVER_US : (normalizeCloudServerKey(serverKey) || CLOUD_SERVER_US)
  storage.set(CLOUD_SERVER_KEY, key)
  if (typeof window !== 'undefined') {
    window.g = window.g || {}
    window.g.baseUrl = getCloudBaseUrl(key)
    if (typeof window.dispatchEvent == 'function') {
      window.dispatchEvent(new CustomEvent('viwoods-cloud-server-change', {
        detail: { serverKey: key, baseUrl: window.g.baseUrl }
      }))
    }
  }
  return key
}

export function getCloudUploadUris(serverKey) {
  const key = isCloudTestEnvironment() ? CLOUD_SERVER_US : (normalizeCloudServerKey(serverKey) || getActiveCloudServerKey())
  const server = CLOUD_SERVERS[key] || CLOUD_SERVERS[CLOUD_SERVER_US]
  return server.upload
}
